module.exports = __webpack_public_path__ + "static/media/arrow-left.75bca977.svg";